<template>
    <b-card :title="$translate('filters')" class="query-filter filter-form" body-class="p-0 mt-3">
        <div>
            <b-row>
                <b-col cols="12" md="6" class="mt-3">
                    <label for="input-customer" class="mb-3"><strong>{{ $translate('customer')
                    }}</strong></label>
                <customer-type-ahead v-model="filtersModel.customer_id" />
               </b-col>
                <b-col cols="12" md="6" class="mt-3">
                    <label for="input-activity" class="mb-3"><strong>{{ $translate('activity')
                    }}</strong></label>
                    <b-input type="text" :placeholder="$translate('search_activity')" v-model="filtersModel.order_search"></b-input>
                </b-col>
                <b-col md="4" cols="12" class="mt-3 text-start">
                    <label for="input-due_start_date" class="mb-3"><strong>{{ $translate('completed') +' '+ $translate('from_date') }}</strong></label>
                    <b-form-input type="date" :max="filtersModel.dueToDate" id="order-completed_start_date"
                        v-model="filtersModel.dueFromDate"></b-form-input>
                </b-col>
                <b-col md="4" cols="12" class="mt-3 text-start">
                    <label for="input-due_end_date" class="mb-3"><strong>{{ $translate('completed') +' '+ $translate('to_date') }}</strong></label>
                    <b-form-input type="date" :min="filtersModel.dueFromDate" id="order-completed_end_date" v-model="filtersModel.dueToDate"></b-form-input>
                </b-col>
                <b-col md="4" cols="12" class="mt-3 text-start">
                    <label for="input-completed_start_date" class="mb-3"><strong>{{ $translate('due') +' '+ $translate('from_date') }}</strong></label>
                    <b-form-input type="date" :max="filtersModel.completedToDate" id="order-due_start_date"
                        v-model="filtersModel.completedFromDate"></b-form-input>
                </b-col>
                <b-col md="4" cols="12" class="mt-3 text-start">
                    <label for="input-completed_end_date" class="mb-3"><strong>{{ $translate('due') +' '+ $translate('to_date') }}</strong></label>
                    <b-form-input type="date" :min="filtersModel.completedFromDate" id="order-due_end_date" v-model="filtersModel.completedToDate"></b-form-input>
                </b-col>

                <b-col md="4" cols="12" class="mt-3 text-start">
                    <label for="input-outstanding_balance" class="mb-3"><strong>{{$translate('outstanding_balance')}}</strong>
                    </label>

                    <b-input-group>
                        <b-form-input id="order-outstanding_balance" type="number"
                            v-model="filtersModel.outstanding_balance"></b-form-input>
                        <template #prepend>
                            <div class="customselect">
                                <select class="form-control" id="order-option-select" v-model="filtersModel.quantityType" value-field="id"
                                    text-field="name" block>
                                    <option v-for="x in quantities" :key="'customselect:--' + x.id" :value="x.id">
                                        {{ x.name }}
                                    </option>
                                </select>
                            </div>
                        </template>
                    </b-input-group>
                </b-col>
                <b-col md="4" cols="12" class="mt-3 text-start">
                    <label for="input-type" class="mb-2"><strong>{{ $translate('activity_type') }}</strong></label>
                    <multiselect id="order-order_type" :placeholder="$translate('select_activity_type')" 
                    v-model="filtersModel.type" 
                    :options="orderTypesArray" 
                    :searchable="true"
                    :deselectLabel="deselectLabel" 
                    :selectedLabel="selectedLabel" 
                    :multiple="true" 
                    :preserve-search="true"
                    :selectLabel="selectLabel" 
                    @remove="selectedOrderTypes"
                    @select="selectedOrderTypes"
                    label="name" track-by="id" :close-on-select="false">
                        <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length" v-show="!isOpen">{{ values.length }} options selected</span></template>
                    </multiselect>
                  </b-col>
                
            </b-row>
        </div>
    </b-card>
</template>

<script>
import CustomerTypeAhead from "@/components/CustomerTypeAhead.vue";
import Multiselect from 'vue-multiselect'
export default {
    name: 'payments-filters',
    props: ['value','orderTypes'],
    components:{CustomerTypeAhead,Multiselect },
    data(){
        return {

            quantities: [
                { id: 1, name: '=' },
                { id: 2, name: '>' },
                { id: 3, name: '<' },
            ],
            orderTypesArray: [],
        }
    },  
    computed: {
        filtersModel: {
            // getter
            get() {
                return this.value
            },
            // setter
            set(val) {
                this.$emit('input', val)
            },
        },

        paymentTransactionStatus() {
            return {
                pending: "Pending",
                processed: "Processed",
                cancelled: "Cancelled"
            }
        },

        transaction_type() {
            return {
                incoming: 'Incoming',
                outgoing: 'Outgoing',
            };
        },

        selectLabel() {
            return this.$translate('click_to_select')
        },
        deselectLabel() {
            return this.$translate('click_to_remove')
        },
        selectedLabel() {
            return this.$translate('selected')
        },
    },

    watch: {},
    async mounted() { 
           
     
        if(this.orderTypes && this.orderTypes.length > 0){

        this.orderTypesArray = this.orderTypes
        }else{
        await this.$store.dispatch("orderType/fetchAll");
        this.orderTypesArray = this.orderTypes
        }
        console.log('ordertype----------',this.orderTypes);
              
      
    },
    methods: {
        selectedOrderTypes() {
            this.orderTypesArray.sort((a, b) => a.name < b.name ? -1 : a.name > b.name ? 1 : 0);
            var selected = this.orderTypesArray.filter(s => this.filtersModel.type.some(item => s.id == item.id))
            console.log('selected-----',selected);
            var notSelected = this.orderTypesArray.filter(s => !this.filtersModel.type.some(item => s.id == item.id))
            this.orderTypesArray = [...selected, ...notSelected];
        }
    },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>